import Tick from "@/svgs/tick.svg";
import clsx from "clsx";

type Props = {
	answeredCount: number;
	questionCount: number;
	includeTick?: boolean;
};

const CountOfQuestionsAnswered = ({ answeredCount, questionCount, includeTick = false }: Props) => {
	const finished = answeredCount === questionCount;
	return (
		<div
			className={clsx(
				"text-12px lg:text-14px italic",
				includeTick ? "flex items-center justify-between" : "-mt-2 mb-4",
			)}
		>
			{answeredCount} out of {questionCount} questions answered
			{includeTick && (
				<div
					className={clsx(
						"border-1 grid h-4 w-4 place-items-center rounded-full",
						finished ? "border-light" : "border-charcoal-light",
					)}
				>
					{finished && <Tick className="stroke-beige" />}
				</div>
			)}
		</div>
	);
};

export default CountOfQuestionsAnswered;
